import { render } from "./ButtonStyle.vue?vue&type=template&id=56dfae55"
import script from "./ButtonStyle.vue?vue&type=script&lang=ts"
export * from "./ButtonStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script